export const CURRENCY = "zł";